export default __webpack_public_path__ + "ffa71d8b056cbface8222bb96caf6088.png";